import React from "react";

const CollapsiblePanel = ({ isCollapsed, onToggle, title, children, className = "" }) => {
  if (isCollapsed) {
    return (
      <div
        className={`flex flex-col items-center bg-white border border-gray-200 rounded-xl dark-shadow py-6 px-3 min-h-[400px] w-[50px] cursor-pointer hover:bg-gray-50/50 transition-all duration-300 ${className}`}
        onClick={onToggle}
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          className="text-gray-400 hover:text-gray-900 transition-colors mb-6 focus:outline-none"
          title="Expand panel"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="11 17 6 12 11 7" />
            <polyline points="18 17 13 12 18 7" />
          </svg>
        </button>
        <span
          style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}
          className="text-gray-800 text-sm font-semibold tracking-wider whitespace-nowrap select-none"
        >
          {title}
        </span>
      </div>
    );
  }

  return (
    <div className={`flex gap-8 flex-col ${className}`}>
      <div
        className="flex items-center gap-2 cursor-pointer select-none text-gray-900 hover:text-blue-600 transition-colors"
        onClick={onToggle}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="text-gray-400"
        >
          <polyline points="13 17 18 12 13 7" />
          <polyline points="6 17 11 12 6 7" />
        </svg>
        <span className="text-gray-900 text-base font-semibold">{title}</span>
      </div>
      {children}
    </div>
  );
};

export default CollapsiblePanel;
